<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'
import type { Testable } from '../../../main'

export interface TableRowProperties extends Testable {
  class?: HTMLAttributes['class']
}

const properties = defineProps<TableRowProperties>()
</script>

<template>
  <tr :class="cn('atabix-table-row', properties.class)" :data-test>
    <slot />
  </tr>
</template>

<style lang="scss">
.atabix-table-row {
  @apply border-b;
  @apply border-table-border;
  @apply text-table-foreground;
  @apply transition-colors;
  @apply hover:bg-table-background-hover;
  @apply data-[state=selected]:bg-table-background-hover;
}

.atabix-table-wrapper--mobile {
  .atabix-table-row {
    @apply flex flex-col w-full gap-4;
    @apply hover:bg-transparent;

    &:not(:last-child) {
      @apply pb-4;
    }
  }
}
</style>
